import { render } from "./CustomCheckboxLists.vue?vue&type=template&id=9ac97076"
import script from "./CustomCheckboxLists.vue?vue&type=script&lang=js"
export * from "./CustomCheckboxLists.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__